var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_4788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9309 21C12.3778 21 11.9042 20.8042 11.5103 20.4125C11.1164 20.0208 10.9194 19.55 10.9194 19C10.9194 18.45 11.1164 17.9792 11.5103 17.5875C11.9042 17.1958 12.3778 17 12.9309 17C13.4841 17 13.9576 17.1958 14.3515 17.5875C14.7455 17.9792 14.9424 18.45 14.9424 19C14.9424 19.55 14.7455 20.0208 14.3515 20.4125C13.9576 20.8042 13.4841 21 12.9309 21ZM12.9309 14C12.3778 14 11.9042 13.8042 11.5103 13.4125C11.1164 13.0208 10.9194 12.55 10.9194 12C10.9194 11.45 11.1164 10.9792 11.5103 10.5875C11.9042 10.1958 12.3778 10 12.9309 10C13.4841 10 13.9576 10.1958 14.3515 10.5875C14.7455 10.9792 14.9424 11.45 14.9424 12C14.9424 12.55 14.7455 13.0208 14.3515 13.4125C13.9576 13.8042 13.4841 14 12.9309 14ZM12.9309 7C12.3778 7 11.9042 6.80417 11.5103 6.4125C11.1164 6.02083 10.9194 5.55 10.9194 5C10.9194 4.45 11.1164 3.97917 11.5103 3.5875C11.9042 3.19583 12.3778 3 12.9309 3C13.4841 3 13.9576 3.19583 14.3515 3.5875C14.7455 3.97917 14.9424 4.45 14.9424 5C14.9424 5.55 14.7455 6.02083 14.3515 6.4125C13.9576 6.80417 13.4841 7 12.9309 7Z",
    fill: "#7B8389"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_4788"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.862061 5C0.862061 2.23858 3.10064 0 5.86206 0H20C22.7614 0 25 2.23858 25 5V24H0.862061V5Z",
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon_more.f34936a3ceb60709697c1b8f3fc760e1.svg";
export { ForwardRef as ReactComponent };